export default __webpack_public_path__ + "static/custom-tooltips-aaf43328c289bc64bbf054420712267a.png";